import { shaderMaterial } from '@react-three/drei';

const vertexShader = `

  uniform float pointSize;
  // uniform float distance;
  uniform float lidarCount;
  uniform float coordMins[MAX_LIDARS];
  uniform float coordMaxs[MAX_LIDARS];
  uniform float infoMins[MAX_LIDARS];
  uniform float infoMaxs[MAX_LIDARS];
  uniform float colorR[MAX_LIDARS];
  uniform float colorG[MAX_LIDARS];
  uniform float colorB[MAX_LIDARS];
  attribute vec4 packedA;
  attribute vec4 packedB;
  varying vec3 vColor;
  varying float vIntensity;
  varying float vVelocity;

  float decodeUint16(float lowByte, float highByte) {
    return lowByte + highByte * 256.0;
  }

  float dequantize(float value, float minValue, float maxValue) {
    if (maxValue == minValue) {
      return minValue;
    }

    return minValue + (value / 65535.0) * (maxValue - minValue);
  }

// 1/35
#define POINT_SIZE_FACTOR (28.5714)

  void main() {
    int id = int(clamp(packedB.w, 0.0, lidarCount - 0.1));
    float coordMin = coordMins[id];
    float coordMax = coordMaxs[id];
    float infoMin = infoMins[id];
    float infoMax = infoMaxs[id];
    float qx = decodeUint16(packedA.x, packedA.y);
    float qy = decodeUint16(packedA.z, packedA.w);
    float qz = decodeUint16(packedB.x, packedB.y);
    float intensity = packedB.z;
    float velocity = packedB.w;
    vVelocity = velocity;
    vIntensity = dequantize(intensity, infoMin, infoMax);
    vColor = vec3(colorR[id], colorG[id], colorB[id]);
    vec3 decodedPosition = vec3(
      dequantize(qx, coordMin, coordMax),
      dequantize(qy, coordMin, coordMax),
      dequantize(qz, coordMin, coordMax)
    );

    // 모델공간
    #if defined(FLIP_X)
    decodedPosition.x = -decodedPosition.x;
    #endif
    #if defined(FLIP_Y)
    decodedPosition.y = -decodedPosition.y;
    #endif
    #if defined(FLIP_Z)
    decodedPosition.z = -decodedPosition.z;
    #endif

    // 
    vec4 clipPos = projectionMatrix * modelViewMatrix * vec4(decodedPosition, 1.0);
    #if defined(FLIP_CLIP_X)
    clipPos.x = -clipPos.x;
    #endif
    #if defined(FLIP_CLIP_Y)
    clipPos.y = -clipPos.y;
    #endif
    #if defined(FLIP_CLIP_Z)
    clipPos.z = -clipPos.z;
    #endif

    gl_Position = clipPos;
    
    float effectivePointSize = pointSize * POINT_SIZE_FACTOR;
    gl_PointSize = max(effectivePointSize, 1.0);
  }
`;

const fragmentShader = `
  uniform float opacity;
  varying vec3 vColor;
  varying float vIntensity;
  varying float vVelocity;

  void main() {
    // gl_FragColor = vec4(vColor, opacity + vIntensity * 0.0);
    // gl_FragColor = vec4(vColor, vIntensity*-1.0*0.001);
    gl_FragColor = vec4(vColor, opacity);
    // gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);
  }
`;

const emptyFloatArray = () => new Float32Array();

/**
 * define으로 축별 반전 제어.
 * 모델 공간: FLIP_X, FLIP_Y, FLIP_Z
 * 클립 공간: FLIP_CLIP_X, FLIP_CLIP_Y, FLIP_CLIP_Z
 * 사용 예: <customPointsMaterial2 defines={{ FLIP_Z: 1, FLIP_CLIP_Z: 1 }} ... />
 */
export const CustomPointsMaterial2 = shaderMaterial(
  {
    pointSize: 0.05,
    // distance: 35,
    lidarCount: 1,
    coordMins: emptyFloatArray(),
    coordMaxs: emptyFloatArray(),
    infoMins: emptyFloatArray(),
    infoMaxs: emptyFloatArray(),
    colorR: emptyFloatArray(),
    colorG: emptyFloatArray(),
    colorB: emptyFloatArray(),
    opacity: 1,
    transparent: true,
  },
  vertexShader,
  fragmentShader,
);
